import gql from "graphql-tag"
import MESSAGE_FRAGMENT from "./message-fragment"

export default gql`
  mutation CreateMessage(
    $message_context: MessageContext!
    $message: MessageInput!
  ) {
    createMessage(message_context: $message_context, message: $message) {
      ...Message
    }
  }
  ${MESSAGE_FRAGMENT}
`
